import { GridRowId } from '@mui/x-data-grid-pro'

/** Rows to open: all when expand all is on, none when off, manually toggled ones flipped */
export const getExpandedIds = (
  rowIds: readonly GridRowId[],
  manuallyToggledIds: readonly GridRowId[],
  isAllExpanded: boolean
): GridRowId[] => {
  const manuallyToggled = new Set(manuallyToggledIds)
  return rowIds.filter((rowId) => manuallyToggled.has(rowId) !== isAllExpanded)
}

/** Rows whose open state differs from the expand all choice */
export const getManuallyToggledIds = (
  rowIds: readonly GridRowId[],
  expandedIds: readonly GridRowId[],
  isAllExpanded: boolean
): GridRowId[] => {
  const expanded = new Set(expandedIds)
  return rowIds.filter((rowId) => expanded.has(rowId) !== isAllExpanded)
}

export const toggleId = (
  ids: readonly GridRowId[],
  rowId: GridRowId
): GridRowId[] =>
  ids.includes(rowId) ? ids.filter((id) => id !== rowId) : [...ids, rowId]

export const haveSameIdsInOrder = (
  left: readonly GridRowId[],
  right: readonly GridRowId[]
): boolean =>
  left.length === right.length && left.every((id, index) => id === right[index])
